import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTA = ({ 
  title = 'Ready to streamline your ISO certification?',
  description = 'Start your free 14-day trial today. No credit card required.',
  primaryButtonText = 'Start Free Trial',
  primaryButtonHref = '/signup',
  secondaryButtonText = 'Contact Sales',
  secondaryButtonHref = '/contact',
  variant = 'default',
  className = '' 
}) => {
  const variantClasses = {
    default: 'bg-muted',
    primary: 'bg-primary text-white',
    gradient: 'bg-gradient-to-r from-primary to-secondary text-white',
  };

  const buttonVariant = variant === 'default' 
    ? 'bg-primary text-white hover:bg-primary-hover' 
    : 'bg-white text-primary hover:bg-white/90';

  const secondaryButtonVariant = variant === 'default'
    ? 'border-primary text-primary hover:bg-primary hover:text-white'
    : 'border-white text-white hover:bg-white hover:text-primary';

  return (
    <section className={`py-16 md:py-24 ${variantClasses[variant]} ${className}`}>
      <div className="container-wide text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
        <p className={`text-lg mb-8 max-w-2xl mx-auto ${variant === 'default' ? 'text-muted-foreground' : 'opacity-90'}`}>
          {description}
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          {primaryButtonText && (
            <a 
              href={primaryButtonHref}
              className={`inline-flex items-center gap-2 px-6 py-3 rounded-md font-medium transition-colors ${buttonVariant}`}
            >
              {primaryButtonText}
              <ArrowRight size={18} />
            </a>
          )}
          {secondaryButtonText && (
            <a 
              href={secondaryButtonHref}
              className={`inline-flex items-center gap-2 px-6 py-3 border rounded-md font-medium transition-colors ${secondaryButtonVariant}`}
            >
              {secondaryButtonText}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

CTA.builderConfig = {
  props: {
    title: {
      type: 'text',
      label: 'Title',
      default: 'Ready to streamline your ISO certification?',
    },
    description: {
      type: 'textarea',
      label: 'Description',
      default: 'Start your free 14-day trial today. No credit card required.',
    },
    primaryButtonText: {
      type: 'text',
      label: 'Primary Button Text',
      default: 'Start Free Trial',
    },
    primaryButtonHref: {
      type: 'text',
      label: 'Primary Button Link',
      default: '/signup',
    },
    secondaryButtonText: {
      type: 'text',
      label: 'Secondary Button Text',
      default: 'Contact Sales',
    },
    secondaryButtonHref: {
      type: 'text',
      label: 'Secondary Button Link',
      default: '/contact',
    },
    variant: {
      type: 'select',
      label: 'Style',
      default: 'default',
      options: [
        { value: 'default', label: 'Default' },
        { value: 'primary', label: 'Primary' },
        { value: 'gradient', label: 'Gradient' },
      ],
    },
  },
};

export default CTA;
